import React from "react";
import { Container, Image } from "react-bootstrap";
import Big_Logo from "../../assets/TRC_Big.svg";
import The_Race_Companion from "../../assets/The_Race_Companion.svg";
import Fantasy_League_Racing from "../../assets/Fantasy_League_Racing.svg";

const Logo: React.FC = () => {
	return (
		<Container fluid style={{ backgroundColor: "transparent" }}>
			<div className="d-flex flex-row justify-content-center align-items-center">
				<div className="">
					<Image src={Big_Logo} alt="TRC Big Logo" fluid className="big-logo" />
				</div>
				<div className="d-flex flex-column align-items-space-between h-100 justify-content-start logo-text ms-1">
					<Image
						src={The_Race_Companion}
						alt="The Race Companion"
						fluid
						className="mb-1"
					/>
					<Image
						src={Fantasy_League_Racing}
						alt="Fantasy League Racing"
						fluid
						className=""
					/>
				</div>
			</div>
		</Container>
	);
};

export default Logo;
